import { TYPE_DATE_COMPARISON } from './input-types';

export const id = 'deliverByDate';
export const apiKey = 'DeliverByDateTime';
export const type = TYPE_DATE_COMPARISON;

export const deliverByDate = {
  id,
  apiKey,
  type,
};
